function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75zm-6-20C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.95 22.75c-.34 0-.64-.23-.73-.57l-4.95-20c-.1-.4.15-.81.55-.91.4-.1.81.14.91.55l4.95 20c.1.4-.15.81-.55.91-.06.01-.12.02-.18.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 15.75c-.33 0-.62-.21-.72-.54-.12-.4.11-.81.51-.93l9.53-2.78c.4-.12.81.11.93.51s-.11.81-.51.93l-9.53 2.78c-.07.02-.14.03-.21.03z"
})));